import { useId } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button";
import { Checkbox } from "@/components/Checkbox/Checkbox";

interface Props {
  termsAndConditions: boolean;
  onTermsChange: (checked: boolean) => void;
  onMoreDetails: () => void;
}

const Summary = ({
  termsAndConditions,
  onTermsChange,
  onMoreDetails,
}: Props) => {
  const intl = useIntl();
  const checkboxId = useId();

  return (
    <>
      <div className="section-title mt-4">
        {intl.formatMessage({
          defaultMessage: "Summary",
          description: "summary",
        })}
      </div>

      <div className="section-card mt-2 flex gap-2 text-sm">
        <div className="shrink-0">
          <Checkbox
            id={checkboxId}
            checked={termsAndConditions}
            onChange={(e) => {
              onTermsChange(e.target.checked);
            }}
            disablePadding
          />
        </div>

        <div className="flex flex-col gap-1 pt-1">
          <label
            className="text-sm font-semibold text-text-primary"
            htmlFor={checkboxId}
          >
            {intl.formatMessage({
              defaultMessage: "I accept the general Terms and Condition",
              description: "flights.acceptGeneralTerms",
            })}
          </label>
          <div className="text-sm text-text-tertiary">
            {intl.formatMessage({
              defaultMessage:
                "Before continuing you must accept our terms of Services",
              description: "flights.acceptGeneralTermsWarning",
            })}
          </div>
          <Button
            size="small"
            variant="textFit"
            onClick={() => onMoreDetails()}
          >
            {intl.formatMessage({
              defaultMessage: "More details",
              description: "moreDetails",
            })}
          </Button>
        </div>
      </div>
    </>
  );
};

export default Summary;
